@if (showDefaultHome) {
  <app-home-default></app-home-default>
}
@if (showManufacturerHome) {
  <app-home-manufacturer></app-home-manufacturer>
}
